import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-server-error',
  templateUrl: './server-error.component.html',
  styleUrls: ['./server-error.component.css'],
})
export class ServerErrorComponent implements OnInit {
  @Input() imgPath = 'assets/error-icons/Big-Eyes.png';
  @Input()
  errorHeading = $localize`:@@serverError.errorHeading:Oops! Something went wrong.`;
  @Input()
  errorMessage = $localize`:@@serverError.errorMessage:Please try again. If the problem persists, <a class="link" href="mailto:merchants@zaver.se" target="_blank">contact&nbsp;us.</a>`;

  constructor() {}

  ngOnInit(): void {}
}
